/** Yoonly domain → help path segment (help.yoonly.eu/{segment}/) and legal path segment (www.yoonly.eu/{segment}/cgv-consommateurs/) */
const YOONLY_DOMAIN_TO_PATHS: Record<string, { helpSegment: string; legalSegment: string }> = {
  'www.befr.yoonly.eu': { helpSegment: 'fr-be', legalSegment: 'be-fr' },
  'www.benl.yoonly.eu': { helpSegment: 'nl', legalSegment: 'be-nl' },
  'www.nl.yoonly.eu': { helpSegment: 'nl', legalSegment: 'nl' },
  'www.yoonly.eu': { helpSegment: 'fr', legalSegment: 'be-fr' },
}

/** Hostname (lowercase) → www.yoonly.eu contact page */
const YOONLY_CONTACT_URL_BY_HOST: Record<string, string> = {
  'www.befr.yoonly.eu': 'https://www.yoonly.eu/be-fr/contact/',
  'befr.yoonly.eu': 'https://www.yoonly.eu/be-fr/contact/',
  'www.benl.yoonly.eu': 'https://www.yoonly.eu/be-nl/contact-opnemen/',
  'benl.yoonly.eu': 'https://www.yoonly.eu/be-nl/contact-opnemen/',
  'www.nl.yoonly.eu': 'https://www.yoonly.eu/nl-nl/contact/',
  'nl.yoonly.eu': 'https://www.yoonly.eu/nl-nl/contact/',
  'www.yoonly.eu': 'https://www.yoonly.eu/be-fr/contact/',
}

const DEFAULT_CONTACT_URL = 'https://www.yoonly.eu/be-fr/contact/'
const DEFAULT_DOMAIN = 'www.yoonly.eu'

class YoonlyService {
  get isYoonly(): boolean {
    return this.getDomain().includes('yoonly')
  }

  /**
   * Returns the current Yoonly menu domain from env or window.location.hostname.
   * Safe to call in SSR (returns DEFAULT_DOMAIN when window is undefined).
   */
  getDomain(): string {
    if (typeof window === 'undefined') return DEFAULT_DOMAIN
    return (window.env?.VUE_APP_MENU_DOMAIN ?? window.location.hostname) as string
  }

  /**
   * Returns help and legal path segments for the current Yoonly domain.
   * Use for building help.yoonly.eu and www.yoonly.eu/cgv-consommateurs URLs.
   */
  getPathSegments(): { helpSegment: string; legalSegment: string } {
    const domain = this.getDomain()
    return YOONLY_DOMAIN_TO_PATHS[domain] ?? YOONLY_DOMAIN_TO_PATHS[DEFAULT_DOMAIN]
  }

  /** Customer-account “contact” link on www.yoonly.eu (replaces mailto per storefront). */
  getContactPageUrl(): string {
    const host = this.getDomain().toLowerCase()
    return YOONLY_CONTACT_URL_BY_HOST[host] ?? DEFAULT_CONTACT_URL
  }
}

export default YoonlyService
